// api/services/auth.ts
import { handleRequest } from '@/api';

export const resetPassword = (email: string): Promise<unknown> => {
    return handleRequest('post', '/password-reset', { email }, 'Password reset email sent.');
};

export const verifyResetToken = (token: string): Promise<unknown> => {
    return handleRequest('get', '/verify-reset-token', { token });
};

export const resetNewPassword = ({ token, newPassword }: { token: string; newPassword: string }): Promise<unknown> => {
    return handleRequest(
        'post',
        '/reset-password',
        { token, new_password: newPassword },
        'Password updated successfully.'
    );
};

export const acceptInvitation = (token: string): Promise<unknown> => {
    return handleRequest('post', '/accept-invitation', { token }, 'Invitation accepted successfully.');
};
